import { ActivatedRoute } from '@angular/router';

export function hasBanner(route: ActivatedRoute | null): boolean {
  let isSearchLayout = false;
  route?.children.forEach((routeChild) => {
    if (routeChild.snapshot.data['hasBanner'] === true) {
      isSearchLayout = true;
      return;
    } else {
      isSearchLayout = hasBanner(routeChild);
    }
  });
  return isSearchLayout;
}
